import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/** 微信小店店铺基本信息（探活） */
export function getShopInfo(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/shop/info", data)
}

/** 绑定微信小店（观星树打单 authCode） */
export function bindShop(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/shop/bind", data)
}

/** 微店订单应用临期/过期/token 提醒 */
export function getOrderAppReminders(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/shop/order-app-reminders", data)
}

/** 当日已读微店订单应用提醒 */
export function ackOrderAppReminders(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/shop/order-app-reminders/ack", data)
}
